var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14849_1917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 11.6667C16.8791 11.6669 17.0834 11.7483 17.2379 11.8941C17.3923 12.0399 17.4852 12.2392 17.4977 12.4512C17.5101 12.6632 17.4412 12.872 17.3048 13.0349C17.1685 13.1978 16.9751 13.3025 16.7642 13.3275L16.6667 13.3334H5.34505L7.25589 15.2442C7.40534 15.3942 7.49211 15.5954 7.49858 15.807C7.50504 16.0187 7.43071 16.2248 7.29068 16.3836C7.15065 16.5424 6.95543 16.642 6.74466 16.662C6.53389 16.6821 6.32338 16.6212 6.15589 16.4917L6.07755 16.4225L2.88589 13.2309C2.33172 12.6775 2.68672 11.745 3.43839 11.6717L3.53422 11.6667H16.6667ZM12.7442 3.57755C12.8877 3.43407 13.0786 3.34787 13.2812 3.33514C13.4837 3.32241 13.6839 3.384 13.8442 3.50838L13.9226 3.57755L17.1142 6.76921C17.6684 7.32255 17.3134 8.25505 16.5617 8.32838L16.4659 8.33338H3.33339C3.12099 8.33314 2.91669 8.25181 2.76225 8.10601C2.6078 7.9602 2.51486 7.76092 2.50241 7.54888C2.48996 7.33685 2.55895 7.12806 2.69527 6.96519C2.8316 6.80231 3.02497 6.69763 3.23589 6.67255L3.33339 6.66671H14.6551L12.7442 4.75588C12.588 4.59961 12.5002 4.38768 12.5002 4.16671C12.5002 3.94574 12.588 3.73382 12.7442 3.57755Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14849_1917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapWhite);
export default __webpack_public_path__ + "static/media/swap-white.37d15d163536ce60602979c07e3d7271.svg";
export { ForwardRef as ReactComponent };